<template>
    <v-row>
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-card-text>
            <div class="grey--text">Total actions</div>
            <div class="text-h4 font-weight-bold">
              {{ summary.actions }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
  
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-card-text>
            <div class="grey--text">Coût total</div>
            <div class="text-h4 font-weight-bold">
              {{ summary.totalCost }} €
            </div>
          </v-card-text>
        </v-card>
      </v-col>
  
      <v-col cols="12" md="4">
        <v-card color="green lighten-4" outlined>
          <v-card-text>
            <div class="green--text text--darken-2">
              Gain financier net (annuel)
            </div>
            <div class="text-h4 font-weight-bold green--text text--darken-3">
              {{ summary.totalProfit }} €
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </template>
  
  <script>
  export default {
    props: {
      summary: {
        type: Object,
        required: true
      }
    }
  }
  </script>